import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { IQuestion } from "./assessment";

export const useGetExamQuestions = (assessmentId: string) => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [questions, setQuestions] = useState<IQuestion[]>([]);
    const [questionsCount, setQuestionsCount] = useState(0); // New state for question count

    useEffect(() => {
        if (assessmentId) {
            getQuestions();
        }
        // eslint-disable-next-line
    }, [assessmentId]);

    const getQuestions = (): Promise<void> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.');
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "slcm_examlearningoutcomes",
            fieldList: ["slcm_questionnumber", "slcm_questiondescription","edtec365_questiontype","slcm_examlearningoutcomesid","edtec365_mcqtype"],
            filters: [{
                group: 0, filters: [
                    { field: "slcm_assessment", type: FieldFilterType.Const, value: assessmentId }
                ]
            }]
        }).unwrap().then((data) => {
            const questionsRecords = data.records.map(record => ({
                questionNumber: record["slcm_questionnumber"] as string,
                questionId: record["slcm_examlearningoutcomesid"] as string,
                questionDescription: record["slcm_questiondescription"] as string,
                questionType: record["edtec365_questiontype"] as number,
                mcqType: record["edtec365_mcqtype"] as number
            }));

            setQuestions(questionsRecords);
            setQuestionsCount(questionsRecords.length); 
        }).catch(error => {
            console.error('Error fetching questions:', error);
        });
    };

    return { questions, questionsCount,setQuestions };
};
